import {defaultIO} from "../DefaultIO";
import {ShoppingExcelExportValueObject} from "../../model/vo/content/ShoppingExcelExportValueObject";

export const ShoppingExcelExportIO = {
    ...defaultIO(
        '/api/v3/contents/shoppings/excels/export',
        ShoppingExcelExportValueObject.construct
    ),
}